import React, { useState } from "react";
import { faqData } from "../../static/data";

const Faq = () => {
  const [activeId, setActiveId] = useState(null);

  const toggleFaq = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  return (
    <section className="faq section" id="faq">
      <div className="faq__header container">
        <h2 className="section__title">
          Frequently Asked Questions
          <span className="section__title-dot"></span>{" "}
        </h2>
        <p className="section__subtitle">
          Everything you need to know about working with me and how I help
          founders scale.
        </p>
      </div>

      <div className="faq__container container">
        <div className="faq__list">
          {faqData.map((item) => (
            <div
              key={item.id}
              className={`faq__item ${activeId === item.id ? "faq__item--active" : ""}`}
            >
              <button
                className="faq__question"
                onClick={() => toggleFaq(item.id)}
                aria-expanded={activeId === item.id}
              >
                <span>{item.question}</span>
                <i className={`uil uil-angle-down faq__icon`}></i>
              </button>
              <div className="faq__answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
